import clsx from "clsx";
import React from "react";

import CommonButton from "../../../components/Button";

type Props = {
  icon: string;
  title: string;
  description: string;
  onCancel: () => void;
  onMoveToManager?: () => void;
  isManager?: boolean;
};

export default function ResultFormat({
  icon,
  title,
  description,
  onCancel,
  onMoveToManager,
  isManager,
}: Props) {
  return (
    <div className="flex flex-col justify-center items-center h-screen">
      <div className="pb-2">
        <img
          src={icon}
          alt="emergency-done-icon"
          className="w-[80px] h-[80px]"
        />
      </div>
      <p className="font-semibold text-2xl leading-[33.6px]">{title}</p>
      <p className="text-center text-base leading-[26px] font-normal whitespace-pre-line text-brand-neutral-60">
        {description}
      </p>
      <div className="fixed bottom-0 bg-white w-full h-bottom-button flex">
        <CommonButton
          variant={isManager === true ? "secondary" : "primary"}
          className={clsx([
            "h-bottom-button text-base font-medium leading-[19px] rounded-none",
            {
              "w-[100px]": isManager === true,
              "w-full": isManager !== true,
            },
          ])}
          onClick={onCancel}
        >
          닫기
        </CommonButton>
        {isManager === true && (
          <CommonButton
            variant="primary"
            className="rounded-none flex-1"
            onClick={onMoveToManager}
          >
            관리자 홈으로 이동
          </CommonButton>
        )}
      </div>
    </div>
  );
}
